// extracted by mini-css-extract-plugin
export default {"wrapper":"RelatedArticles_wrapper__BMs26","listArticles":"RelatedArticles_listArticles__tTOZ0"};